import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FloatingMenu from './FloatingMenu';
import { FILTER_MENU_CONTENT_MAPPING, MENU_CONTENT_TYPES } from './consts';

const FilterGroup = ({ title, filters, activeFilters, navigationCondition, applyNavigation }) => {

    const isActive = filters.reduce((active, filter) => active || !!activeFilters[filter.id], false);

    if (!filters.length) {
        return null;
    }

    return (
        <FloatingMenu data={filters.map((filter) => ({ ...filter, component: FILTER_MENU_CONTENT_MAPPING[filter.display_type] }))}
            title={title}
            menuTitle={title}
            activeFilters={activeFilters}
            navigationCondition={navigationCondition}
            applyNavigation={applyNavigation}
            isGrouped
            titleClass={classNames('more-filter-menu', { active: isActive })}
            contentType={MENU_CONTENT_TYPES.FILTERS_GROUP}
            trackOpen/>
    );
};

FilterGroup.propTypes = {
    title: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    activeFilters: PropTypes.object
};

export default FilterGroup;
